var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Row",
        [
          _c(
            "Col",
            { attrs: { span: "3" } },
            [
              _c(
                "Content",
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入体检任务名称",
                      "prefix-icon": "el-icon-search",
                    },
                    model: {
                      value: _vm.search.taskName,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "taskName", $$v)
                      },
                      expression: "search.taskName",
                    },
                  }),
                  _c(
                    "el-table",
                    {
                      ref: "table",
                      attrs: {
                        data: _vm.taskList,
                        "highlight-current-row": "",
                        "highlight-selection-row": "",
                        "show-header": false,
                        "max-height": _vm.maxHeight,
                        "row-class-name": _vm.tableRowClassName,
                      },
                      on: { "row-click": _vm.handleRowClick },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          prop: "name",
                          "show-overflow-tooltip": "",
                          "max-width": "50",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Col",
            { attrs: { span: "21" } },
            [
              _c("ErrorReportList", {
                ref: "errorReportList",
                style: { "overflow-y": "auto", "box-sizing": "border-box" },
                attrs: {
                  currentRowIndex: _vm.currentRowIndex,
                  taskId: _vm.taskId,
                },
                on: {
                  "update:taskId": function ($event) {
                    _vm.taskId = $event
                  },
                  "update:task-id": function ($event) {
                    _vm.taskId = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }